import { parse } from 'date-fns'

/** 一覧の期間フィルター */
export type ItemPeriodFilter = 'current' | 'ended' | 'all'

export const PERIOD_FILTER_OPTIONS: { value: ItemPeriodFilter; label: string }[] = [
  { value: 'current', label: '公開予定・公開中' },
  { value: 'ended', label: '公開終了' },
  { value: 'all', label: 'すべて' },
]

export const OTAC_PERIOD_FILTER_OPTIONS: { value: ItemPeriodFilter; label: string }[] = [
  { value: 'current', label: 'メンテナンス予定・実施中' },
  { value: 'ended', label: 'メンテナンス終了' },
  { value: 'all', label: 'すべて' },
]

export type NotificationPublishStatus = 'scheduled' | 'active' | 'ended'

export const NOTIFICATION_STATUS_LABELS: Record<NotificationPublishStatus, string> = {
  scheduled: '公開予定',
  active: '公開中',
  ended: '公開終了',
}

export type OtacMaintenanceStatus = 'scheduled' | 'active' | 'ended'

export const OTAC_STATUS_LABELS: Record<OtacMaintenanceStatus, string> = {
  scheduled: 'メンテナンス予定',
  active: 'メンテナンス中',
  ended: 'メンテナンス終了',
}

export const parseNotificationDate = (value: string | null | undefined): Date | null => {
  if (!value) {
    return null
  }
  const date = parse(value, 'yyyy/MM/dd HH:mm:ss', new Date())
  return Number.isNaN(date.getTime()) ? null : date
}

export const getPublishStatusFromDates = (
  start: Date | null,
  end: Date | null,
  now = new Date(),
): NotificationPublishStatus => {
  if (end && end < now) {
    return 'ended'
  }
  if (start && start > now) {
    return 'scheduled'
  }
  return 'active'
}

export const getNotificationPublishStatus = (
  notification: { startDisplayAt: string | null; endDisplayAt: string | null },
  now = new Date(),
): NotificationPublishStatus => {
  return getPublishStatusFromDates(
    parseNotificationDate(notification.startDisplayAt),
    parseNotificationDate(notification.endDisplayAt),
    now,
  )
}

const matchesPeriodFilter = (status: 'scheduled' | 'active' | 'ended', filter: ItemPeriodFilter): boolean => {
  if (filter === 'all') {
    return true
  }
  if (filter === 'ended') {
    return status === 'ended'
  }
  return status === 'scheduled' || status === 'active'
}

export const notificationMatchesFilter = (
  notification: { startDisplayAt: string | null; endDisplayAt: string | null },
  filter: ItemPeriodFilter,
  now = new Date(),
): boolean => {
  const status = getNotificationPublishStatus(notification, now)
  return matchesPeriodFilter(status, filter)
}

export const parseOtacDate = (value: string | null | undefined): Date | null => {
  if (!value) {
    return null
  }
  const date = parse(value, "yyyy-MM-dd'T'HH:mm:ss", new Date())
  return Number.isNaN(date.getTime()) ? null : date
}

export const getOtacMaintenanceStatus = (
  schedule: { maintenanceStartAt: string | null; maintenanceEndAt: string | null },
  now = new Date(),
): OtacMaintenanceStatus => {
  return getPublishStatusFromDates(
    parseOtacDate(schedule.maintenanceStartAt),
    parseOtacDate(schedule.maintenanceEndAt),
    now,
  )
}

export const otacMatchesFilter = (
  schedule: { maintenanceStartAt: string | null; maintenanceEndAt: string | null },
  filter: ItemPeriodFilter,
  now = new Date(),
): boolean => {
  const status = getOtacMaintenanceStatus(schedule, now)
  return matchesPeriodFilter(status, filter)
}
